const callDirections = ["INBOUND", "OUTBOUND"];

const callConstants = {
  callDirections,
};
export default callConstants;
